module.exports = __webpack_public_path__ + "assets/89ff94624212883962812167bac700e0.png";